import axios from "axios";
import { handleAdminApiResponseError } from "./adminAuth";

// En dev : toujours /api + setupProxy (ignore REACT_APP_BACKEND_URL du système)
const envUrl =
  process.env.NODE_ENV === "development"
    ? ""
    : (process.env.REACT_APP_BACKEND_URL || "").trim().replace(/\/$/, "");
export const API = envUrl ? `${envUrl}/api` : "/api";
export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    handleAdminApiResponseError(error);
    return Promise.reject(error);
  },
);

/** En-tête JWT candidat (les routes admin utilisent les cookies NCB). */
export const authHeader = (token) => ({ headers: { Authorization: `Bearer ${token}` } });

export async function fetchAdminSession() {
  const { data } = await api.get("/auth/get-session");
  return data?.user || null;
}

export async function adminSignIn(email, password) {
  return api.post("/auth/sign-in/email", { email, password });
}

export async function adminSignOut() {
  return api.post("/auth/sign-out", {});
}

export async function fetchAuthProviders() {
  const { data } = await api.get("/auth-providers");
  return data?.providers || {};
}
